import {
    GET_ACCOUNT_STATEMENTS,
    SET_ACCOUNT_STATEMENTS,
    SET_ACCOUNT_STATEMENTS_PAGINATION,
    RESET_ACCOUNT_STATEMENTS
} from "../actions/accountStatements"

const initialState = {
    count: 0,
    rows: [],
    pagination: {
        page: 1,
        perPage: 25,
        start: 1,
        end: 25, 
    },

}

export default (state = initialState, {
    type,
    payload
}) => {
    let newState = {};
    switch (type) {
        case SET_ACCOUNT_STATEMENTS:
            newState = {
                ...state,
                ...payload,
                pagination: {
                    ...state.pagination,
                },
            };
            newState.pagination.start = newState.pagination.page > 1 ? ((newState.pagination.page - 1) * newState.pagination.perPage) + 1 : 1;
            newState.pagination.end = newState.pagination.start + newState.pagination.perPage - 1;
            newState.pagination.end = newState.pagination.end > newState.count ? newState.count : newState.pagination.end;
            return newState;
        case SET_ACCOUNT_STATEMENTS_PAGINATION:
            newState = {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...payload,
                },
            };
            newState.pagination.start = newState.pagination.page > 1 ? ((newState.pagination.page - 1) * newState.pagination.perPage) + 1 : 1;
            newState.pagination.end = newState.pagination.start + newState.pagination.perPage - 1;
            newState.pagination.end = newState.pagination.end > newState.count ? newState.count : newState.pagination.end;
            return newState;
        case RESET_ACCOUNT_STATEMENTS:
            return initialState;
        case GET_ACCOUNT_STATEMENTS:
        default:
            return state;
    }
}
